import { useState } from 'react'
import { IconChevronDown } from '@tabler/icons-react'
import classNames from 'classnames'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import styles from './SiteFooterColumn.module.scss'
import { SiteFooterColumnProps } from './SiteFooterColumn.types'

export const SiteFooterColumn = ({
  title,
  panelId,
  isMobile,
  variant = 'links',
  children,
}: SiteFooterColumnProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const isExpanded = isMobile ? isOpen : true

  const handleToggle = () => {
    if (!isMobile) {
      return
    }

    setIsOpen((prev) => {
      return !prev
    })
  }

  return (
    <div
      className={classNames(styles.column, {
        [styles.columnOpen]: isOpen,
        [styles.hours]: variant === 'hours',
      })}>
      <button
        type='button'
        className={styles.title}
        aria-expanded={isExpanded}
        aria-controls={panelId}
        onClick={handleToggle}>
        <Typography
          tag={TypographyTag.span}
          variant={TypographyVariant.BodyRegularBold}
          className={styles.titleText}>
          {title}
        </Typography>
        <IconChevronDown
          size={18}
          stroke={2}
          className={styles.chevron}
          aria-hidden='true'
        />
      </button>
      <div id={panelId} className={styles.body}>
        {children}
      </div>
    </div>
  )
}
